import type { MRLocationHistory } from '@pn/core/domain/intel/mr-location-history';
import type { ApiMineralRightsLocationHistory } from '@pn/services/api/intel/types';

export const apiMRLocationHistoryMapper: {
  toDomainMRLocationHistory: (
    apiIntel: ApiMineralRightsLocationHistory
  ) => MRLocationHistory;
} = {
  toDomainMRLocationHistory: (apiMRLocationHistory) => {
    const zones = apiMRLocationHistory.zones.map((zone) => ({
      tract: Number(zone.tract),
      description: zone.zone_description,
    }));

    return {
      id: apiMRLocationHistory.header_id,
      issueDate: apiMRLocationHistory.issue_date,
      agreementNumber: apiMRLocationHistory.agreement_id,
      agreementType: apiMRLocationHistory.agreement_type,
      status: apiMRLocationHistory.status,
      area: apiMRLocationHistory.area,
      bonus: apiMRLocationHistory.bonus,
      termLength: apiMRLocationHistory.term_length,
      province: apiMRLocationHistory.province,
      rentCad: apiMRLocationHistory.rent_cad,
      zones,
      participants: apiMRLocationHistory.participants.map((participant) => ({
        createdAt: participant.created_at,
        ownershipPercentage: participant.ownership_percentage,
        name: participant.name,
        companyBrandId: participant.company_brand_id,
      })),
    };
  },
};
